<div class="banner"
     [ngClass]="{ 'closing': closing, 'narrow': isNarrow }"
     tabindex="0">
    @if (displayIcon) {
        <div class="icon-con">
            <ws-ace-icon [glyph]="displayIcon"></ws-ace-icon>
        </div>
    }
    <div class="content" [class.dismissable]="enableDismiss">
        @if (header) {
            <h3>{{ header }}</h3>
        }
        @if (content && !contentIsComponent) {
            <span>{{ content }}</span>
        }
        @if (content && contentIsComponent) {
            <ng-container #contentComponent></ng-container>
        }
    </div>
    @if (enableDismiss) {
        <button
            class="close"
            type="button"
            (click)="handleClose()">
            <ws-ace-icon glyph="times"></ws-ace-icon>
        </button>
    }
</div>
